












import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: {
    Typography
  }
})
export default class SideModalHeader extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
}
